"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const building_blocks_ui_common_1 = require("@acko-tech/building-blocks.ui.common");
const building_blocks_ui_common_2 = require("@acko-tech/building-blocks.ui.common");
const Container = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_2.Flex) `
  height: 100vh;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  background-color: white;
`;
const Wrapper = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_2.Flex) `
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 60%;
`;
const Heading = building_blocks_ui_common_1.styled.div `
  color: #000000;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  margin-top: 20px;
  text-align: center;

  @media (min-width: 768px) {
    color: #151619;
    font-weight: 700;
    font-size: 24px;
    line-height: 37px;
    margin-top: 20px;
  }
`;
const SubHeading = building_blocks_ui_common_1.styled.div `
  color: #5b5675;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin-top: 10px;
  text-align: center;

  @media (min-width: 768px) {
    color: #8990a1;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    margin-top: 5px;
  }
`;
const IMG = building_blocks_ui_common_1.styled.img `
  @media (min-width: 768px) {
    height: 150px;
    width: 150px;
  }
`;
const Loader = () => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Container, null,
            react_1.default.createElement(Wrapper, null,
                react_1.default.createElement(IMG, { src: "https://acko-home-prod.ackoassets.com/images/animationLoader.gif", alt: "Loading..." }),
                react_1.default.createElement(Heading, null, "Please wait, we're Fetching your vehicle details"),
                react_1.default.createElement(SubHeading, null, "It will take a few seconds")))));
};
exports.default = Loader;
//# sourceMappingURL=AnimatedLoader.js.map